import { ChangeEvent, useCallback } from "react";
import { AttributeType } from "@evergis/api";
import { IOption } from "@evergis/ui";

import { UpdateAttribute } from "../../../../hooks/attributes/useAttributes";
import { ImportAttribute } from "../types";

export const useAttributeUpdate = (id: string, updateAttribute: UpdateAttribute<ImportAttribute>) => {
  const changeDisabled = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      updateAttribute(id, { disabled: !event.target.checked });
    },
    [id],
  );

  const changeName = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const { value } = event.target;

      updateAttribute(id, { name: value });
    },
    [id],
  );

  const changeAlias = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      updateAttribute(id, { alias: event.target.value });
    },
    [id],
  );

  const changeType = useCallback(
    (items: IOption[]) => {
      updateAttribute(id, { type: items[0].value as AttributeType });
    },
    [id],
  );

  return { changeDisabled, changeName, changeAlias, changeType } as const;
};
